module.exports = __webpack_public_path__ + "static/media/1en.5349070c.jpg";